'use client';

export default function GlobalError() {
  return (
    <html>
      <body>
        <h1>We&#39;re Sorry</h1>
        <p>We&#39;ve encountered a problem please reload the page!</p>
      </body>
    </html>
  );
}
